import { CheckCircle } from "lucide-react";

interface Props {
  number: number;
  title: string;
  done: boolean;
}

export function SectionDivider({ number, title, done }: Props) {
  return (
    <div className="flex items-center gap-3 pt-6 pb-2">
      <div className={`shrink-0 h-8 w-8 rounded-full flex items-center justify-center text-sm font-bold ${
        done ? "bg-success text-success-foreground" : "bg-muted text-muted-foreground"
      }`}>
        {done ? <CheckCircle className="h-4.5 w-4.5" /> : number}
      </div>
      <h2 className="text-base font-bold tracking-tight">{title}</h2>
    </div>
  );
}
